module.exports = __webpack_public_path__ + "static/media/onoiwa-nav-r1.7f8f03d5.png";